export default "__VITE_ASSET__DzYbafNP__"